/* eslint-disable */
import APP_ACTIONS from '../constants/app-actions';

const initialState = {
    triggedBy: null
};

const backgroundDisabled = (state = initialState, action) => {
    switch (action.type) {
        case APP_ACTIONS.SET_BACKGROUND_DISABLED:
            return { ...state, triggedBy: action.payload.triggedBy };
        default:
            return state;
    }
};

export default backgroundDisabled;


/** WEBPACK FOOTER **
 ** ./src/reducers/background-disabled.js
 **/